import React, { Suspense, lazy } from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import { PapiUser } from '@wix/da-types-papi';
import AvatarEdit from './AvatarEdit';
import ProfileIdentityMobile from '@wix/da-shared-react/pkg/ProfileIdentityMobile';
import ProfileStats from './ProfileStats';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import IconButton from '@wix/da-shared-react/pkg/Button/IconButton';
import PencilIcon from '@wix/da-shared-react/pkg/Icons/Pencil';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';

import s from './ProfileIdentity.scss';

export interface Props {
  profileOwnerUser: PapiUser;
  stats: object;
  tagline: string;
  url: string;
  className?: string;
  isCurrentUserProfileOwner: boolean;
  isMobile?: boolean;
  aboutModuleId?: any;
}

export interface State {
  isAboutMeDialogOpen: boolean;
}

const LoadableAboutMeEditPopup = lazy(() =>
  import(/* webpackChunkName: "owner" */ '../AboutMe/AboutMeEditPopup')
);

class ProfileIdentity extends React.Component<Props & WithTranslation, State> {
  state = {
    isAboutMeDialogOpen: false,
  };

  renderDesktop() {
    const {
      profileOwnerUser,
      stats,
      tagline,
      className,
      aboutModuleId,
      isCurrentUserProfileOwner,
    } = this.props;
    const { isAboutMeDialogOpen } = this.state;
    return (
      <div className={classnames(s['root'], className)}>
        {isCurrentUserProfileOwner && <AvatarEdit />}
        <span>
          <UserAvatar
            user={profileOwnerUser}
            className={s['user-avatar']}
            withTooltip={false}
          />
        </span>
        <div className={s['user-details']}>
          <div className={s['user-link']}>
            <UserLink
              className={s['user-link-text']}
              symbolClassName={s['user-link-icon']}
              user={profileOwnerUser}
              withTooltip={false}
            />
          </div>
          {tagline && (
            <div className={s['user-label']}>
              {tagline}
              {isCurrentUserProfileOwner && aboutModuleId && (
                <IconButton
                  className={s['tagline-edit']}
                  onClick={() => this.setState({ isAboutMeDialogOpen: true })}
                >
                  <PencilIcon size={IconSize.SMALL} />
                </IconButton>
              )}
            </div>
          )}
          <ProfileStats {...stats} />
        </div>
        {isCurrentUserProfileOwner && isAboutMeDialogOpen && (
          <Suspense fallback={<ChunkLoadingPopover />}>
            <LoadableAboutMeEditPopup
              username={profileOwnerUser.username}
              moduleId={aboutModuleId}
              isWide={false}
              onClose={() => this.setState({ isAboutMeDialogOpen: false })}
            />
          </Suspense>
        )}
      </div>
    );
  }

  renderMobile() {
    const { profileOwnerUser, stats, tagline, className } = this.props;
    return (
      <ProfileIdentityMobile
        user={profileOwnerUser}
        tagline={tagline}
        className={className}
        statsComponent={<ProfileStats {...stats} />}
      />
    );
  }

  render() {
    return this.props.isMobile ? this.renderMobile() : this.renderDesktop();
  }
}

export default withMobileContext(withTranslation()(ProfileIdentity));
